import "./style.css";

export default class Events {
  static selector = ".page-events";

  constructor(block) {
    this.block = block;
    this.mounted = false;
  }

  onReady = () => {
    this.mounted = true;
  };

  onPageChangeComplete = () => {
    this.onComplete();
  };

  onComplete = () => {};
}
